function parseHex(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return [r, g, b];
}

function toHex(r: number, g: number, b: number): string {
  const clamp = (v: number) => Math.max(0, Math.min(255, Math.round(v)));
  return '#' + [clamp(r), clamp(g), clamp(b)].map((v) => v.toString(16).padStart(2, '0')).join('');
}

export function mix(color1: string, color2: string, weight: number): string {
  const [r1, g1, b1] = parseHex(color1);
  const [r2, g2, b2] = parseHex(color2);
  const w = weight / 100;
  return toHex(r1 * w + r2 * (1 - w), g1 * w + g2 * (1 - w), b1 * w + b2 * (1 - w));
}

function rgba(r: number, g: number, b: number, alpha: number): string {
  const a = alpha / 100;
  // Blend against white background to produce a hex value
  const blendR = r * a + 255 * (1 - a);
  const blendG = g * a + 255 * (1 - a);
  const blendB = b * a + 255 * (1 - a);
  return toHex(blendR, blendG, blendB);
}

const weights = [100, 75, 50, 25, 10] as const;

export function computeDerivedColors(variables: Record<string, string>): Record<string, string> {
  const primary = variables['xrpPrimaryColor'] || '#2a3c50';
  const secondary = variables['xrpSecondaryColor'] || '#7aa0c4';
  const tertiary = variables['xrpTertiaryColor'] || '#c9d7e7';
  const quaternary = variables['xrpQuaternaryColor'] || '#e6edf5';

  const derived: Record<string, string> = {};

  for (const w of weights) {
    derived[`primaryColor${w}`] = mix(primary, '#617593', w);
    derived[`secondaryColor${w}`] = mix(secondary, '#ffffff', w);
    derived[`tertiaryColor${w}`] = mix(tertiary, '#ffffff', w);
    derived[`quaternaryColor${w}`] = mix(quaternary, '#ffffff', w);
  }

  for (const w of weights) {
    derived[`white${w}`] = rgba(255, 255, 255, w);
    derived[`black${w}`] = rgba(0, 0, 0, w);
  }

  return derived;
}
